class Card {
  constructor (element) {
    this.element = element
    this.callback = this.removeDelay.bind(this)
    this.init()
  }

  init () {
    this.element.addEventListener('mouseover', this.callback)
  }

  removeDelay() {
    this.element.style.setProperty('--anim-delay', '0ms')
    this.element.removeEventListener('mouseover', this.callback)
  }
}

export default {
  selector: '.js-delay',
  Source: Card
}
